import actions from './actions';

const setInterstitalDisabled = payload => dispatch => {
  dispatch(actions.setInterstitalDisabled(payload));
};

export default {
  setInterstitalDisabled,
};
